export const EMPHATIC_MESSAGE = ''
export const DATA_TEST_ID = 'curriculum-preview-banner'
